import React from "react";

import CallToAction from "../components/call-to-action";
import FAQs from "../components/faqs";
import Footer from "../components/footer";
import Header from "../components/header";
import Hero from "../components/hero";
import Mentions from "../components/mentions";
import Features from "../components/features";
import PageHead from "../components/page-head";
import PromoBanner from "../components/promo-banner";
import TemplatePreview from "../components/template-preview";
import ExamplePreview from "../components/example-preview";

const IndexPage = () => {
  return (
    <>
      <Header bottomBorder={false} absolute />
      <Hero />
      <TemplatePreview />
      <ExamplePreview />
      <Features />
      <Mentions />
      <CallToAction />
      <FAQs />
      <Footer />
      <PromoBanner shouldShow={true} />
    </>
  );
};

export default IndexPage;

export const Head = ({ location }) => (
  <PageHead
    title="Chrome Extension Development Kit | JS, React, and Vue starter templates & example extensions"
    includeSuffix={false}
    location={location}
  />
);
